// assets/vh-c2.js — WP-P19: Chip-Filter (Stärke x Trägeröl) + Größen-Chips der Collection-V3
// "Listing zuerst"-Bauart. ES5, kein Framework, keine Timer, kein MutationObserver (N-115-Analogie,
// 200-ms-Timer-Test-Pflicht vor jedem Push). Wirkt auf [data-c2-st]/[data-c2-tr]/[data-c2-count]/
// [data-c2-empty]/[data-c2-reset] aus sections/vh-c2-kopf.liquid + sections/vh-c2-grid.liquid und auf
// [data-c2-size] aus snippets/vh-c2-karte.liquid. Sheets laufen unveraendert ueber assets/vh-v2.js
// (geladen aus sections/vh-c2-kopf.liquid VOR dieser Datei).
//
// WP-P27 Teil B (r5, §5 B4): Die Leiste hat jetzt zwei .vh-c2-bar__group (Staerke/Traegeroel) in EINER
// .vh-c2-bar__row (Teil A) statt zwei getrennter .vh-c2-bar__row — der Gruppen-Selektor in setPressed()
// laeuft deshalb ueber .vh-c2-bar__group. Neu: [data-c2-filter-tr] aus sections/vh-c2-oele.liquid setzt
// den Traegeroel-Filter, setzt die Staerke auf "alle" zurueck und scrollt zum Grid.
//
// WP-P35 Integration r6 (25.09.2026, Auftrag I Punkt 1): dritte, unabhaengige Chip-Gruppe fuer
// sections/vh-c2-grid.liquid Modus "sortiment" — [data-c2-cat] statt Staerke-/Traegeroel-Chips, filtert
// auf das data-c2-kategorie-Attribut des Karten-Wrappers (.vh-c2-catwrap, nur im Sortiment-Modus im DOM;
// im Default-Modus "oele" gibt es keine [data-c2-cat]-Buttons und keine [data-c2-kategorie]-Wrapper, state.cat
// bleibt 'alle' und applyFilter() verhaelt sich exakt wie vorher — additiv, keine Verhaltensaenderung im
// Default-Modus). Card-Selektor bleibt bewusst [data-c2-traeger] (Karten haben dieses Attribut in JEDEM
// Modus, auch sortiment — vh-c2-produktdaten liefert dort teils leere Werte, das ist unschaedlich).
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };

  var state = { st: 'alle', tr: 'alle', cat: 'alle' };

  function applyFilter() {
    var visible = 0;
    $$('[data-c2-traeger]').forEach(function (card) {
      var key = card.getAttribute('data-c2-traeger');
      var st = card.getAttribute('data-c2-staerke');
      var catWrap = card.closest('[data-c2-kategorie]');
      var cat = catWrap ? catWrap.getAttribute('data-c2-kategorie') : '';
      var show = (state.st === 'alle' || st === state.st) && (state.tr === 'alle' || key === state.tr || key === 'beide') && (state.cat === 'alle' || cat === state.cat);
      card.hidden = !show;
      if (show) visible += 1;
    });

    var count = $('[data-c2-count]');
    if (count) count.textContent = visible;

    var empty = $('[data-c2-empty]');
    if (empty) empty.hidden = visible !== 0;
  }

  function setPressed(group, activeBtn, attr) {
    if (!group) return;
    $$('[' + attr + ']', group).forEach(function (b) {
      b.setAttribute('aria-pressed', b === activeBtn ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var stBtn = e.target.closest('[data-c2-st]');
    if (stBtn) {
      setPressed(stBtn.closest('.vh-c2-bar__group'), stBtn, 'data-c2-st');
      state.st = stBtn.getAttribute('data-c2-st');
      applyFilter();
      return;
    }

    var trBtn = e.target.closest('[data-c2-tr]');
    if (trBtn) {
      setPressed(trBtn.closest('.vh-c2-bar__group'), trBtn, 'data-c2-tr');
      state.tr = trBtn.getAttribute('data-c2-tr');
      applyFilter();
      return;
    }

    var catBtn = e.target.closest('[data-c2-cat]');
    if (catBtn) {
      setPressed(catBtn.closest('.vh-c2-bar__group'), catBtn, 'data-c2-cat');
      state.cat = catBtn.getAttribute('data-c2-cat');
      applyFilter();
      return;
    }

    var ftBtn = e.target.closest('[data-c2-filter-tr]');
    if (ftBtn) {
      state.tr = ftBtn.getAttribute('data-c2-filter-tr');
      state.st = 'alle';
      $$('[data-c2-tr]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c2-tr') === state.tr ? 'true' : 'false'); });
      $$('[data-c2-st]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c2-st') === 'alle' ? 'true' : 'false'); });
      applyFilter();
      var grid = document.getElementById('vh-c2-grid');
      if (grid) grid.scrollIntoView({ behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      return;
    }

    var resetBtn = e.target.closest('[data-c2-reset]');
    if (resetBtn) {
      state.st = 'alle';
      state.tr = 'alle';
      state.cat = 'alle';
      $$('[data-c2-st]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c2-st') === 'alle' ? 'true' : 'false'); });
      $$('[data-c2-tr]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c2-tr') === 'alle' ? 'true' : 'false'); });
      $$('[data-c2-cat]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c2-cat') === 'alle' ? 'true' : 'false'); });
      applyFilter();
      return;
    }

    var sizeBtn = e.target.closest('[data-c2-size]');
    if (sizeBtn) {
      var karte = sizeBtn.closest('.vh-c2-karte');
      if (!karte) return;

      var sizeGroup = sizeBtn.closest('.vh-c2-sizes');
      if (sizeGroup) {
        $$('[data-c2-size]', sizeGroup).forEach(function (b) {
          var checked = b === sizeBtn ? 'true' : 'false';
          if (b.getAttribute('aria-checked') !== checked) b.setAttribute('aria-checked', checked);
        });
      }

      var vid = sizeBtn.getAttribute('data-vid') || '';
      var price = sizeBtn.getAttribute('data-price') || '';
      var compare = sizeBtn.getAttribute('data-compare') || '';
      var unit = sizeBtn.getAttribute('data-unit') || '';
      var available = sizeBtn.getAttribute('data-available') === 'true';

      var idInput = $('[data-c2-vid]', karte);
      if (idInput && idInput.value !== vid) idInput.value = vid;

      var priceEl = $('[data-c2-price]', karte);
      if (priceEl && priceEl.textContent !== price) priceEl.textContent = price;

      var unitEl = $('[data-c2-unit]', karte);
      if (unitEl && unitEl.textContent !== unit) unitEl.textContent = unit;

      var compareEl = $('[data-c2-compare]', karte);
      if (compareEl) {
        var hasCompare = compare !== '';
        if (compareEl.textContent !== compare) compareEl.textContent = compare;
        if (compareEl.hidden !== !hasCompare) compareEl.hidden = !hasCompare;
      }

      var addBtn = $('[data-js-product-add-to-cart]', karte);
      if (addBtn && addBtn.disabled !== !available) addBtn.disabled = !available;

      var labelEl = $('[data-c2-btn-label]', karte);
      if (labelEl) {
        var label = available ? 'In den Warenkorb' : 'Ausverkauft';
        if (labelEl.textContent !== label) labelEl.textContent = label;
      }
      return;
    }
  });
})();
